import { GET_ACTIVE_CITIES_PENDING, GET_ACTIVE_CITIES_SUCCESS, GET_ACTIVE_CITIES_FAILURE } from './types';

const initialState = {
    loading: false,
    activeCities: [],
    error: ''
}

const activeCities = (state = initialState, action) => {
    switch (action.type) {
        case GET_ACTIVE_CITIES_PENDING:
            return {
                loading: true,
                activeCities: [],
                error: '',
            }
        case GET_ACTIVE_CITIES_SUCCESS:
            return {
                loading: false,
                activeCities: action.payload,
                error: ''
            }
        case GET_ACTIVE_CITIES_FAILURE:
            return {
                loading: false,
                activeCities: [],
                error: action.payload
            }
        default:
            return state
    }
}

export default activeCities;